/* HAUNTSY conversion layer — vanilla JS, no dependencies */
(function () {
  'use strict';
  var CFG = window.hdConfig || { moneyFormat: '${{amount}}', tiers: [], routes: { add: '/cart/add', change: '/cart/change', cart: '/cart' } };

  /* ---------------- helpers ---------------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents) {
    cents = Number(cents) || 0;
    var fmt = CFG.moneyFormat || '${{amount}}';
    function delim(n, prec, th, dec) {
      var parts = (n / 100).toFixed(prec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts[1] ? parts[0] + dec + parts[1] : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return delim(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return delim(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delim(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return delim(cents, 2, "'", '.');
        default: return delim(cents, 2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  }
  function img(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 160);
  }
  function post(url, body) {
    return fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function getCart() { return fetch(CFG.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  /* ---------------- lazy autoplay videos ---------------- */
  var vio = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        if (!v.src && v.dataset.src) { v.src = v.dataset.src; v.load(); }
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      } else if (!v.paused) { v.pause(); }
    });
  }, { rootMargin: '150px 0px', threshold: 0.15 }) : null;
  function initVideos(ctx) {
    $$('video[data-hd-video]', ctx).forEach(function (v) {
      v.muted = true;
      if (vio) vio.observe(v); else if (v.dataset.src) { v.src = v.dataset.src; v.autoplay = true; }
    });
  }

  /* ---------------- gallery ---------------- */
  function initGallery(root) {
    var track = $('[data-hd-track]', root);
    if (!track) return;
    var slides = $$('[data-hd-slide]', track);
    var counter = $('[data-hd-current]', root);
    var thumbsWrap = root.parentElement.querySelector('[data-hd-thumbs]');
    var thumbs = thumbsWrap ? $$('[data-hd-thumb]', thumbsWrap) : [];
    var current = 0;
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    function setActive(i) {
      if (i === current) return;
      current = i;
      if (counter) counter.textContent = i + 1;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      var t = thumbs[i];
      if (t && thumbsWrap) thumbsWrap.scrollTo({ left: t.offsetLeft - thumbsWrap.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
    }
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { setActive(Math.round(track.scrollLeft / track.clientWidth)); });
    }, { passive: true });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var prev = $('[data-hd-prev]', root), next = $('[data-hd-next]', root);
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
  }

  /* ---------------- urgency: countdown + delivery ETA ---------------- */
  function addBusinessDays(d, n) {
    var x = new Date(d);
    while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; }
    return x;
  }
  function subBusinessDays(d, n) {
    var x = new Date(d);
    while (n > 0) { x.setDate(x.getDate() - 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; }
    return x;
  }
  function fmtDate(d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }
  function initUrgency(el) {
    var min = parseInt(el.dataset.min, 10) || 7, max = parseInt(el.dataset.max, 10) || 14;
    var now = new Date();
    var eta = $('[data-hd-eta]', el);
    if (eta) eta.textContent = fmtDate(addBusinessDays(now, min)) + ' – ' + fmtDate(addBusinessDays(now, max));
    var parts = (el.dataset.eventDate || '').split('-');
    if (parts.length !== 3) return;
    var event = new Date(+parts[0], +parts[1] - 1, +parts[2], 23, 59, 59);
    var cutoff = subBusinessDays(new Date(+parts[0], +parts[1] - 1, +parts[2]), max);
    cutoff.setHours(23, 59, 59, 0);
    var row = $('[data-hd-cutoff]', el), clock = $('[data-hd-clock]', el);
    if (!row || !clock) return;
    function tick() {
      var ms = cutoff - new Date();
      if (ms <= 0 || new Date() > event) { row.hidden = true; return false; }
      row.hidden = false;
      var s = Math.floor(ms / 1000), d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
      clock.textContent = (d > 0 ? d + 'd ' : '') + String(h).padStart(2, '0') + 'h ' + String(m).padStart(2, '0') + 'm ' + String(sec).padStart(2, '0') + 's';
      return true;
    }
    if (tick()) setInterval(tick, 1000);
  }

  /* ---------------- product form + bundles + sticky bar ---------------- */
  function initProduct(root) {
    var form = $('form.hd-buy', root);
    if (!form) return;
    var qtyInput = $('[data-hd-qty]', form);
    var atc = $('[data-hd-atc]', form);
    var label = $('[data-hd-atc-label]', form);
    var baseLabel = label ? label.textContent.trim() : 'Add to cart';
    var priceEl = $('[data-hd-price]', root);
    var compareEl = $('[data-hd-compare]', root);
    var stickyPrice = $('[data-hd-sticky-price]', root);
    var errorEl = $('[data-hd-error]', form);
    var radios = $$('.hd-bundle input[type="radio"]', form);

    function update() {
      var sel = radios.filter(function (r) { return r.checked; })[0];
      if (!sel) return;
      $$('.hd-bundle', form).forEach(function (l) { l.classList.toggle('is-active', l.contains(sel)); });
      var q = parseInt(sel.value, 10) || 1;
      qtyInput.value = q;
      var total = money(sel.dataset.total);
      if (label) label.textContent = baseLabel + ' · ' + total;
      if (priceEl) priceEl.textContent = total;
      if (compareEl) compareEl.textContent = money(sel.dataset.compare);
      if (stickyPrice) stickyPrice.textContent = total;
    }
    radios.forEach(function (r) { r.addEventListener('change', update); });
    update();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (atc.classList.contains('is-loading')) return;
      atc.classList.add('is-loading');
      if (errorEl) errorEl.classList.remove('is-visible');
      var fd = new FormData(form);
      post(CFG.routes.add, { items: [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity')) || 1 }] })
        .then(function () { return Cart.open(true); })
        .catch(function (err) {
          if (errorEl) { errorEl.textContent = (err && (err.description || err.message)) || 'Something went wrong. Please try again.'; errorEl.classList.add('is-visible'); }
        })
        .then(function () { atc.classList.remove('is-loading'); });
    });

    var sticky = $('[data-hd-sticky]', root);
    if (sticky && 'IntersectionObserver' in window) {
      var stickyBtn = $('[data-hd-sticky-btn]', sticky);
      var aboveFold = true;
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        aboveFold = e.boundingClientRect.top > 0;
        var show = !e.isIntersecting && !aboveFold;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        stickyBtn.tabIndex = show ? 0 : -1;
      }).observe(atc);
      stickyBtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else atc.click();
      });
    }
  }

  /* ---------------- cart drawer ---------------- */
  var Cart = (function () {
    var root = document.getElementById('hd-cart');
    if (!root) return { open: function () { window.location.href = CFG.routes.cart; return Promise.resolve(); }, refresh: function () { return Promise.resolve(); } };
    var panel = $('.hd-cart__panel', root);
    var body = $('[data-hd-cart-body]', root);
    var foot = $('[data-hd-cart-foot]', root);
    var lastFocus = null;
    var state = null;

    function tiersHTML(count) {
      var tiers = (CFG.tiers || []).slice().sort(function (a, b) { return a.qty - b.qty; });
      if (!tiers.length) return '';
      var top = tiers[tiers.length - 1];
      var next = tiers.filter(function (t) { return count < t.qty; })[0];
      var reached = tiers.filter(function (t) { return count >= t.qty; }).pop();
      var unit = function (n) { return n === 1 ? CFG.unitName : CFG.unitNamePlural; };
      var msg;
      if (!next) msg = '🎃 <b>' + top.pct + '% OFF</b> unlocked — the best deal is yours!';
      else if (reached) msg = '🔥 ' + reached.pct + '% OFF unlocked! Add ' + (next.qty - count) + ' more ' + unit(next.qty - count) + ' for <b>' + next.pct + '% OFF</b>';
      else msg = 'Add ' + (next.qty - count) + ' more ' + unit(next.qty - count) + ' to unlock <b>' + next.pct + '% OFF</b>';
      var pct = Math.min(100, (count / top.qty) * 100);
      var marks = '<span class="' + (count >= 1 ? 'is-on' : '') + '">1 item</span>' + tiers.map(function (t) {
        return '<span class="' + (count >= t.qty ? 'is-on' : '') + '">' + t.qty + ' · ' + t.pct + '% off</span>';
      }).join('');
      return '<div class="hd-tier"><div class="hd-tier__msg">' + msg + '</div><div class="hd-tier__bar"><div class="hd-tier__fill" style="width:' + pct + '%"></div></div><div class="hd-tier__marks">' + marks + '</div></div>';
    }

    function linesHTML(cart) {
      return cart.items.map(function (it, i) {
        var discounted = it.final_line_price < it.original_line_price;
        var discTitles = (it.line_level_discount_allocations || []).map(function (a) { return a.discount_application && a.discount_application.title; }).filter(Boolean);
        return '<div class="hd-line">' +
          '<a href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image, 200)) + '" alt="" loading="lazy" width="76" height="76">' : '') + '</a>' +
          '<div>' +
            '<div class="hd-line__title">' + esc(it.product_title) + '</div>' +
            (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="hd-line__disc" style="color:var(--hd-muted)">' + esc(it.variant_title) + '</div>' : '') +
            (discTitles.length ? '<div class="hd-line__disc">✓ ' + esc(discTitles.join(', ')) + '</div>' : '') +
            '<div class="hd-line__row">' +
              '<div class="hd-qty"><button type="button" data-hd-change="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="Decrease quantity">−</button><span>' + it.quantity + '</span><button type="button" data-hd-change="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button></div>' +
              '<div class="hd-line__price">' + (discounted ? '<s>' + money(it.original_line_price) + '</s>' : '') + money(it.final_line_price) + '</div>' +
            '</div>' +
            '<button type="button" class="hd-line__remove" data-hd-change="' + (i + 1) + '" data-q="0">Remove</button>' +
          '</div>' +
        '</div>';
      }).join('');
    }

    function upsellHTML(cart, count) {
      if (!cart.items.length) return '';
      var tiers = (CFG.tiers || []).slice().sort(function (a, b) { return a.qty - b.qty; });
      var next = tiers.filter(function (t) { return count < t.qty; })[0];
      if (!next) return '';
      var it = cart.items[0];
      var add = next.qty - count;
      return '<div class="hd-upsell">' +
        (it.image ? '<img src="' + esc(img(it.image, 160)) + '" alt="" loading="lazy" width="56" height="56">' : '<span></span>') +
        '<div><div class="hd-upsell__t">Add ' + add + ' more & save ' + next.pct + '% on all</div><div class="hd-upsell__s">One for the porch, one for the hallway 👻</div></div>' +
        '<button type="button" class="hd-btn" data-hd-upsell="' + it.variant_id + '" data-q="' + add + '">+ Add</button>' +
      '</div>';
    }

    function sumHTML(cart) {
      var saved = cart.original_total_price - cart.total_price;
      return '<div class="hd-sum__row"><span>Subtotal</span><span>' + money(cart.original_total_price) + '</span></div>' +
        (saved > 0 ? '<div class="hd-sum__row hd-sum__row--save"><span>Bundle savings</span><span>−' + money(saved) + '</span></div>' : '') +
        '<div class="hd-sum__row"><span>Shipping</span><span style="color:var(--hd-green);font-weight:700">FREE</span></div>' +
        '<div class="hd-sum__row hd-sum__row--total"><span>Total</span><span>' + money(cart.total_price) + '</span></div>';
    }

    function render(cart) {
      state = cart;
      var count = cart.item_count;
      $('[data-hd-cart-count]', root).textContent = count ? '(' + count + ')' : '';
      if (!count) {
        body.innerHTML = '<div class="hd-cart__empty">' + emptyIcon + '<p style="font-size:16px;color:var(--hd-text);font-weight:700">Your cart is empty… for now.</p><a class="hd-btn hd-btn--auto" href="' + (CFG.routes.root || '/') + '">Find your scare</a></div>';
        foot.hidden = true;
      } else {
        foot.hidden = false;
        body.innerHTML = tiersHTML(count) + '<div>' + linesHTML(cart) + '</div>' + upsellHTML(cart, count) + notesHTML;
        $('[data-hd-sum]', root).innerHTML = sumHTML(cart);
      }
      updateBubble(count);
    }

    var notesHTML = '';
    var emptyIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 7h14l-1.3 11.2a2 2 0 0 1-2 1.8H8.3a2 2 0 0 1-2-1.8z"/><path d="M9 10V6.5a3 3 0 0 1 6 0V10"/></svg>';
    $$('.hd-cart__note', body).forEach(function (n) { notesHTML += n.outerHTML; });

    function updateBubble(count) {
      $$('[ref="cartBubbleCount"]').forEach(function (el) { el.textContent = count < 100 ? String(count) : ''; el.classList.toggle('hidden', count === 0); });
      $$('[ref="cartBubble"]').forEach(function (el) { el.classList.toggle('visually-hidden', count === 0); });
      $$('cart-icon').forEach(function (el) { el.classList.toggle('header-actions__cart-icon--has-cart', count > 0); });
      try { sessionStorage.setItem('cart-count', JSON.stringify({ value: String(count), timestamp: Date.now() })); } catch (e) {}
    }

    function busy(on) { root.classList.toggle('is-busy', on); }

    function refresh() { return getCart().then(render); }

    function open(fresh) {
      lastFocus = document.activeElement;
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('hd-lock');
      setTimeout(function () { panel.focus({ preventScroll: true }); }, 50);
      if (fresh || !state) { busy(true); return refresh().then(function () { busy(false); }); }
      return Promise.resolve();
    }
    function close() {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('hd-lock');
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-hd-cart-close],[data-hd-change],[data-hd-upsell]');
      if (!t) return;
      if (t.hasAttribute('data-hd-cart-close')) { close(); return; }
      busy(true);
      var req = t.hasAttribute('data-hd-upsell')
        ? post(CFG.routes.add, { items: [{ id: Number(t.getAttribute('data-hd-upsell')), quantity: Number(t.dataset.q) || 1 }] }).then(getCart)
        : post(CFG.routes.change, { line: Number(t.getAttribute('data-hd-change')), quantity: Math.max(0, Number(t.dataset.q)) });
      req.then(render).catch(function () { return refresh(); }).then(function () { busy(false); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });

    // Route every cart link / header cart icon to the drawer
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (!a || root.contains(a)) return;
      var href = a.getAttribute('href') || '';
      var path = href.split('?')[0].split('#')[0];
      if (path === CFG.routes.cart || /\/cart\/?$/.test(path)) {
        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault();
        open(true);
      }
    });

    return { open: open, close: close, refresh: refresh };
  })();
  window.hdCart = Cart;

  /* ---------------- smooth scroll to buy box ---------------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-hd-scroll-buy]');
    if (!a) return;
    var target = document.getElementById('buy');
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---------------- boot ---------------- */
  function boot(ctx) {
    initVideos(ctx);
    $$('[data-hd-gallery]', ctx).forEach(initGallery);
    $$('[data-hd-urgency]', ctx).forEach(initUrgency);
    $$('[data-hd-product]', ctx).forEach(initProduct);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
